<template>
  <div class="select" :class="[{ 'has-error': error }, theme]">
    <label class="select__label" v-if="label" :for="_uid">{{ getLabel }}</label>
    <v-select
      :id="_uid"
      :options="options"
      :value="value"
      :placeholder="placeholderText"
      :clearable="clearable"
      :searchable="searchable"
      @input="setSelected"
      v-bind="$attrs"
    >
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <SvgIcon name="caret" />
        </span>
      </template>
      <template #no-options="{}">
        <span>{{ $t('notFound') }}</span>
      </template>
      <template #selected-option-container="{ option, deselect, multiple, disabled }">
        <div class="vs__selected" :class="disabled" v-if="multiple">{{ option.label }}</div>
        <div class="vs__selected" :class="disabled" v-else>{{ option.label }}</div>
      </template>
    </v-select>
  </div>
</template>

<script>
import { SvgIcon } from '@/components/ui'

export default {
  name: 'Select',
  components: { SvgIcon },
  props: {
    value: {
      type: Object || Array,
      required: false,
    },
    options: {
      type: Array,
      required: true,
      default() {
        return []
      },
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: {
      type: String || Boolean,
      required: false,
    },
    theme: {
      type: String,
      required: false,
    },
  },
  computed: {
    placeholderText() {
      return this.placeholder || 'Select option'
    },
    getLabel() {
      return typeof this.error === 'string' ? this.parseVeeError(this.error) : this.label
    },
  },
  methods: {
    setSelected(val) {
      this.$emit('onSelect', val)
    },
    parseVeeError(err) {
      return err.replaceAll('{field}', '')
    },
  },
}
</script>

<style lang="scss" scoped>
.select {
  &__label {
    display: block;
    font-size: 14px;
    line-height: 16px;
    color: $dark;
    margin-bottom: 5px;
  }
  &.has-error {
    .select__label {
      color: $red;
    }
  }
}
</style>

<style lang="scss">
.select {
  .vs__dropdown-toggle {
    background: white;
    border: 1px solid rgba(155, 166, 183, 0.2);
    padding: 0;
    color: $text;
    border-radius: 5px;
    transition: border 0.25s $ease, background 0.25s $ease;
    &:hover {
      border-color: $gray;
      background: white;
    }
  }
  .vs__selected-options {
    padding: 0;
    min-width: 1px;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
  }
  .vs__search,
  .vs__search:focus {
    margin: 0;
    padding: 7px 16px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    border: 0;
    color: $dark;
    height: auto;
  }
  .vs__selected {
    position: relative;
    color: $text;
    background: transparent;
    margin: 0;
    padding: 7px 14px;
    border: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    + .vs__selected {
      padding-left: 0;
      margin-left: -6px;
      &::before {
        display: inline-block;
        content: ',';
        position: absolute;
        left: -13px;
        top: 13px;
      }
    }
    + .vs__search {
      margin-left: -6px;
      padding-left: 0;
    }
  }
  .vs__actions {
    padding: 0 16px 0 16px;
  }
  .vs__open-indicator {
    font-size: 8px;
    color: $text;
  }
  .vs__dropdown-menu {
    top: calc(100% + 1px);
    padding: 0;
    box-shadow: none;
    border: 0;
    background: white;
    padding: 22px 0;
    border-radius: 0 0 5px 5px;
    border: 0;
    box-shadow: 0px 4px 112px rgba(0, 0, 0, 0.12);
  }
  .vs__dropdown-option {
    position: relative;
    padding: 10px 20px 10px 54px;
    color: $dark;
    background: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: background 0.1s $ease, color 0.25s $ease;
    &::before {
      display: inline-block;
      content: ' ';
      position: absolute;
      left: 20px;
      top: 50%;
      width: 20px;
      height: 20px;
      transform: translateY(-50%);
      border: 1px solid #eeeeee;
      border-radius: 3px;
      background: url('~@/assets/icons/checkbox-arrow.svg') center center / 8px 8px no-repeat;
      transition: 0.1s $ease;
    }
  }
  .vs__dropdown-option--highlight {
    &::before {
      border-color: $primary;
    }
  }
  .vs__dropdown-option--selected {
    &::before {
      background-color: $primary;
    }
  }
  .vs__no-options {
    padding: 14px 20px;
    font-size: 14px;
    text-align: center;
  }
  .vs--single.vs--open .vs__selected {
    opacity: 1;
    font-weight: 700;
  }
  &.has-error {
    .vs__dropdown-toggle {
      border-color: $red;
    }
  }
}
</style>
